import { useState, useContext } from "react";
import styled from "styled-components";

import { Colors, Spacing } from "@paclife/plds.tokens";
import { AppContext } from "context/AppContext";

import Typography from "common/Typography/Typography";
import OverflowMenu from "common/OverflowMenu/OverflowMenu";

import MFAModal from "components/MFAModal/MFAModal";
import DeleteModal from "components/DeleteModal/DeleteModal";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
    display: flex;
    margin-bottom: ${Spacing[32]};
`;

const Label = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${Spacing[8]};
`;

const Text = styled(Typography)`
    display: block;
    color: ${({ color }) => color};
    &.label-text {
        margin-right: ${Spacing[4]};
    }
`;

const SeondaryEmail = () => {
    const { t } = useTranslation("loginSecurity");
    const {
        account: { secondaryEmail }
    } = useContext(AppContext);

    const [editModal, setEditModal] = useState(false);
    const [swapModal, setSwapModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    // useEffect(() => {
    //     setPrimaryFactorId(getFactorId());
    //     console.log("getFactorId()", getFactorId())
    // }, []);

    // const getFactorId = () => {        
    //     for (const element of factors) { 
    //         if (element.factorType === "primaryemail") { 
    //             return element.id;  
    //         }
    //     }
    // }

    const openEditModal = () => {
        setEditModal(true);
    };

    // const openSwapModal = () => {
    //     setSwapModal(true);
    // };

    const closeMFAModal = () => {
        setEditModal(false);
        setSwapModal(false);
    };

    const openDeleteModal = () => {
        setDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setDeleteModal(false);
    };

    const menu = [
        {
            icon: "edit",
            color: Colors.neutral1000,
            action: "Update",
            onClick: openEditModal
        },
        // {
        //     icon: "refresh",
        //     color: Colors.neutral1000,
        //     action: "Make Primary",
        //     onClick: openSwapModal
        // },
        {
            icon: "delete",
            color: Colors.destructive,
            action: "Delete",
            onClick: openDeleteModal
        }
    ];

    return (
        <div>
            <Wrapper>
                <OverflowMenu
                    icon={!secondaryEmail ? "add" : "overflowMenuVertical"}
                    color={Colors.blue600}
                    onClick={openEditModal}
                    menu={menu}
                />
                <div>
                    <Label>
                        <Text
                            className="label-text"
                            variant="caption"
                            display="block"
                            color={Colors.textBodyLight}
                            bold
                        >
                            {t("email.secondary")}
                        </Text>
                    </Label>
                    <Text color={Colors.textBodyLight}>
                        {secondaryEmail || t("email.placeholder")}
                    </Text>
                </div>
            </Wrapper>
            {(editModal || swapModal) && (
                <MFAModal
                    closeModal={closeMFAModal}
                    factorType="email"
                    subType={swapModal ? "swap" : "secondary"}
                    defaultValue={secondaryEmail}
                />
            )}
            {deleteModal && (
                <DeleteModal
                    closeModal={closeDeleteModal}
                    factorType="email"
                    subType="secondary"
                    defaultValue={secondaryEmail}
                />
            )}
        </div>
    );
};

export default SeondaryEmail;
